import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CaseContentWrapper from '../components/content/CaseContentWrapper';
import { ContentDefault } from '../components';


const Content = (props) => {
  const { selectedCase, mainClass, selectedSpecimen } = props;
  const isCaseSelected = Object.keys(selectedCase).length > 0;

  const shouldRenderCaseContent = isCaseSelected || selectedSpecimen.id;
  return (
    <main className={mainClass}>
      {shouldRenderCaseContent
        ? <CaseContentWrapper isValidation={props.isValidation} />
        : <ContentDefault />}
    </main>
  );
};

const mapStateToProps = ({ _case: { selectedCase, selectedSpecimen } }) => {
  return {
    selectedCase,
    selectedSpecimen,
  };
};

Content.propTypes = {
  selectedCase: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    specimens: PropTypes.array,
  }).isRequired,
};

export default connect(mapStateToProps)(Content);
